define('TescoMobile_Checkout/js/view/basket-exit-modal',["jquery", "uiComponent", "Magento_Ui/js/modal/modal", "jquery/jquery-storageapi"], function ($, uiComponent, modal) {
  "use strict";

  const storage = $.initNamespaceStorage('tm-basket-exit-modal-storage').sessionStorage;
  return uiComponent.extend({
    isHalf: false,
    percentDown: 50,
    percentUp: 5,
    defaults: {
      idleTimeDesktop: 30000,
      idleTimeMobile: 10000,
      modalSelector: '#basket-exit-modal',
      position: $(window).scrollTop(),
      content: ''
    },
    initialize: function () {
      this._super();
    },
    showModal: function () {
      if (storage.get('exitIntent') !== '1') {
        const options = {
          type: 'popup',
          innerScroll: true,
          clickableOverlay: false,
          opened: function () {
            storage.set('exitIntent', '1');
          }
        };
        const popup = modal(options, $(this.modalSelector));
        $(this.modalSelector).modal('openModal');
      }
    },
    ctaBtnEvent: function () {
      location.href = this.checkoutUrl;
    },
    startTimer: function () {
      let self = this;
      mediaCheck({
        media: '(min-width: 1008px)',
        entry: function () {
          self.initStartTimer(parseInt(self.idleTimeDesktop));
        },
        exit: function () {
          const $window = $(window);
          self.initStartTimer(parseInt(self.idleTimeMobile));
          $('.page-wrapper').on('click', 'header.page-header, footer.page-footer', function () {
            self.showModal();
          });
          function scrollToTop(start) {
            $window.on('scroll', function () {
              if ($window.scrollTop() < self.position && start - self.percentUp > self.getPercent()) {
                self.showModal();
                $window.off('scroll');
              }
              self.position = $window.scrollTop();
            });
          }
          $window.on('scroll', function () {
            self.isHalf = self.getPercent() > self.percentDown;
            if ($window.scrollTop() < self.position && self.isHalf) {
              $window.off('scroll');
              scrollToTop(self.getPercent());
              self.isHalf = false;
            }
            self.position = $window.scrollTop();
          });
        }
      });
    },
    initStartTimer: function (idle) {
      let time;
      let init = () => {
        time = this.resetTimer(time, idle);
      };
      window.onload = init;
      $(document).on('load mousemove keydown touchstart click', init);
      window.addEventListener('scroll', init);
    },
    resetTimer: function (t, i) {
      let self = this;
      clearTimeout(t);
      t = setTimeout(() => {
        self.showModal();
      }, i);
      return t;
    },
    getPercent: function () {
      const windowTop = $(window).scrollTop(),
        documentHeight = $(document).height(),
        windowHeight = $(window).height();
      return windowTop / (documentHeight - windowHeight) * 100;
    }
  });
});

